import { DestroyRef, inject, isDevMode, Service, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { interval, startWith, switchMap } from "rxjs";

import { CommunicationsApiService } from "../../../shared/services/communications-api-service";

const POLL_INTERVAL = isDevMode() ? 1000 * 60 * 10 : 1000 * 60;

@Service()
export class Adaa4UnreadService {
  private readonly _communicationsApiService = inject(CommunicationsApiService);

  count = signal(0);

  public watch(destroyRef: DestroyRef): void {
    interval(POLL_INTERVAL)
      .pipe(
        startWith(0),
        switchMap(() => this._communicationsApiService.countUnreadMessages({ useLoader: false })),
        takeUntilDestroyed(destroyRef)
      )
      .subscribe((res) => this.count.set(res.responseData ?? 0));
  }

  public refresh(): void {
    this._communicationsApiService
      .countUnreadMessages({ useLoader: false })
      .subscribe((res) => this.count.set(res.responseData ?? 0));
  }
}
